import { useEffect, useState } from "react";

import { Colors } from "@blueprintjs/core";

import { isWorkspaceAdmin } from "@/components/helpers/workspace/permissions";
import { Tabs } from "@/components/pieces/Tabs";
import { Tab } from "@/types/tabs";

export const WORKSPACE_TABS_CONFIG = [
  {
    key: "your-users",
    label: "Your Users",
    linkTo: "/workspace/users",
  },
  {
    key: "groups",
    label: "Groups",
    linkTo: "/workspace/groups",
  },
];

export function getWorkspaceAdminTabs(): Tab[] {
  let workspaceAdminTabs = WORKSPACE_TABS_CONFIG;

  if (isWorkspaceAdmin()) {
    workspaceAdminTabs = workspaceAdminTabs.concat([
      {
        key: "settings",
        label: "Settings",
        linkTo: "/workspace/settings",
      },
      {
        key: "billing",
        label: "Billing",
        linkTo: "/workspace/billing",
      },
      {
        key: "integrations",
        label: "Integrations",
        linkTo: "/workspace/integrations",
      },
    ]);
  }
  return workspaceAdminTabs;
}

interface WorkspaceAdminTabsProps {
  initialTab?: string;
  tabs?: Tab[];
  onTabChange?: (key?: string) => void;
}

export function WorkspaceAdminTabs({
  initialTab = WORKSPACE_TABS_CONFIG[0].key,
  tabs = WORKSPACE_TABS_CONFIG,
  onTabChange,
}: WorkspaceAdminTabsProps) {
  const [tab, setTab] = useState(
    tabs.find((tab) => tab.key === initialTab) || tabs[0],
  );

  useEffect(() => {
    if (onTabChange) {
      onTabChange(tab.key);
    }
  }, [tab]);

  useEffect(() => {
    const newTab = tabs.find((tab) => tab.key === initialTab) || tabs[0];
    setTab(newTab);
  }, [initialTab, tabs]);

  return (
    <Tabs
      tabs={tabs}
      tab={tab}
      onTabChange={setTab}
      style={{
        background: Colors.WHITE,
        boxShadow: undefined,
        borderTop: "none",
      }}
    />
  );
}
